import React from 'react';
import { Redirect } from 'react-router-dom';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import EventDetails from '../../shared/EventDetails';
import WelcomeBlock from './WelcomeBlock';
import isEnabledRoute from '../../../hooks/use-enabled-route';

const WelcomeWrapper: React.FC = (): JSX.Element | null => {
  const data = useEventSettings() as EventSettingsContextType;
  const enabledRoute = isEnabledRoute(data?.landingPage);

  if (!data || arePageFlagsPending(data)) return null;

  if (!data.welcomeEnabled) {
    return <Redirect to={enabledRoute} />;
  }

  return (
    <>
      <EventDetails details={data}/>
      <WelcomeBlock {...data}/>
    </>
  );
};



export default WelcomeWrapper;
